import React from 'react';

import { useResponsive } from '@actual-app/components/hooks/useResponsive';
import { View } from '@actual-app/components/view';

import { Sidebar } from './Sidebar';

export function FloatableSidebar() {
  const { isNarrowWidth } = useResponsive();

  return isNarrowWidth ? null : (
    <View
      style={{
        height: '100%',
        position: 'relative',
        zIndex: 100,
        flexShrink: 0,
      }}
    >
      <Sidebar />
    </View>
  );
}
